// extracted by mini-css-extract-plugin
export default {"error":"Select_error__G9Vqo","wrapper":"Select_wrapper__3rusq","input":"Select_input__GeSsG","white":"Select_white__IJU0S","err":"Select_err__G19tZ"};